import React, { useEffect, useState } from "react";
import { Button, Col, Container, Form, Row, Card } from "react-bootstrap";
import moment from "moment";
import CustomPagination from "../../../components/Common/CustomPagination";
import CustomerReport from "./Components/CustomerReport";
import ProductPerformance from "./Components/ProductPerformance";
import { CUSTOMER_REPORTS_API, REVENUE_REPORTS_API } from "../../../services/ApiCalls";
import dataHandler from "../../../hooks/dataHandler";
import Axios from "../../../services/Axios";
import { useTranslation } from "react-i18next";

const hotelId = localStorage.getItem("_id");

const ReportManagement = () => {
  const { t } = useTranslation();

  const [state, setState] = useState({ tab: "tab1" });

  const [body, setBody] = useState({
    page: 1,
    limit: 10,
    rating: "",
    status: "Visible",
  });

  const [data, setData] = useState([]);


  useEffect(() => {
    setData([
      {
        id: 1,
        user: "User A / 8932",
        rating: 5,
        comment:
          "Excellent stay! Clean rooms and friendly staff. Will visit again soon!",
        date: "2025-10-15",
        status: "Visible",
      },
      {
        id: 2,
        user: "User B / 9011",
        rating: 4,
        comment: "Great location and service. Highly recommend.",
        date: "2025-10-12",
        status: "Visible",
      },
    ]);
  }, [body.page]);

  const renderStars = (rating) => (
    <div>
      {[...Array(5)].map((_, i) => (
        <span
          key={i}
          style={{
            color: i < rating ? "#f5c518" : "#ddd",
            fontSize: "16px",
            marginRight: 2,
          }}
        >
          ★
        </span>
      ))}
    </div>
  );

  const [dataRevenueReports, setDataRevenueReports] = useState([]);
  const [loading, setLoading] = useState(false);
  const [loadingRevenue, setLoadingRevenue] = useState(false);
 

  const fetchRevenueTrendsReports = async () => {
    setLoadingRevenue(true);
    try {
      const payload = {};
      const res = await REVENUE_REPORTS_API(payload);
      if (res?.data?.status === "success") {
        setDataRevenueReports(res?.data?.data || {});
      } else {
        console.error("Error:", res?.data?.message || "Failed to fetch");
      }
    } catch (err) {
      console.error("API error:", err);
    } finally {
      setLoadingRevenue(false);
    }
  };

  useEffect(() => {
    if (state?.tab === "tab1") {
      // fetchCustomerReports();
    } else if (state?.tab === "tab2") {
      fetchRevenueTrendsReports();
    }
  }, [state]);

  return (
    <section className="report-management py-4">
      <Container>
        <Row className="mb-4">
          <Col>
            <h4 className="fw-bold text-dark mb-0">
              {t("report.title")}
            </h4>
          </Col>

          <Col lg="12" className="my-2">
            <div className="tab-frame mt-3">
              <div className="clearfix">
                <input
                  type="radio"
                  name="tab"
                  id="tab1"
                  checked={state.tab == "tab1"}
                  onClick={() => setState({ tab: "tab1" })}
                />
                <label htmlFor="tab1">
                  <span className="me-2">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="18"
                      height="18"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      data-lucide="users"
                      class="lucide lucide-users w-4 h-4 mr-2"
                    >
                      <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"></path>
                      <path d="M16 3.128a4 4 0 0 1 0 7.744"></path>
                      <path d="M22 21v-2a4 4 0 0 0-3-3.87"></path>
                      <circle cx="9" cy="7" r="4"></circle>
                    </svg>
                  </span>
                  {t("report.tabs.customerReport")}
                </label>

                <input
                  type="radio"
                  name="tab"
                  id="tab2"
                  checked={state.tab == "tab2"}
                  onClick={() => setState({ tab: "tab2" })}
                />
                <label htmlFor="tab2">
                  <span className="me-2">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="18"
                      height="18"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      data-lucide="bed"
                      class="lucide lucide-bed w-4 h-4 mr-2"
                    >
                      <path d="M2 4v16"></path>
                      <path d="M2 8h18a2 2 0 0 1 2 2v10"></path>
                      <path d="M2 17h20"></path>
                      <path d="M6 8v9"></path>
                    </svg>
                  </span>
                  {t("report.tabs.productPerformance")}
                </label>
              </div>
            </div>

            <div>
              {state.tab == "tab1" && (
                <div className="comonbg custreport mt-3">
                  <CustomerReport />
                </div>
              )}

              {state.tab == "tab2" && (
                <div className="comonbg productperformance mt-3">
                  <ProductPerformance data={dataRevenueReports} />
                </div>
              )}
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default ReportManagement;
